import { render, staticRenderFns } from "./modalRejectCompany.vue?vue&type=template&id=30c0c34d&scoped=true"
import script from "./modalRejectCompany.vue?vue&type=script&lang=js"
export * from "./modalRejectCompany.vue?vue&type=script&lang=js"
import style0 from "./modalRejectCompany.vue?vue&type=style&index=0&id=30c0c34d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c0c34d",
  null
  
)

export default component.exports